import { useSyncExternalStore } from "react";
import {
  type DiagnosticsSummary,
  getDiagnosticsSummary,
  subscribeToDiagnostics,
} from "#diagnostics-store";

/** Live (coalesced to ~2 Hz) counts and the latest sample, for the Diagnostics settings page. */
export function useDiagnosticsStatus(): DiagnosticsSummary {
  return useSyncExternalStore(subscribeToDiagnostics, getDiagnosticsSummary, getDiagnosticsSummary);
}
